/**
 * Parses the dev token for display in the UI.
 *
 * Dev token format: `dev:<tenantId>:<userId>:<roles>`. Returns a
 * friendly subset for the top-bar badge. Never falls back to an
 * invalid-looking string — returns null if we can't parse.
 */

export interface ParsedDevToken {
  tenantId: string;
  userId: string;
  tenantShort: string;
  userShort: string;
  roles: string[];
}

export function parseDevToken(token: string): ParsedDevToken | null {
  if (!token.startsWith('dev:')) return null;
  const parts = token.slice(4).split(':');
  if (parts.length < 3) return null;
  const [tenantId = '', userId = '', rolesStr = ''] = parts;
  return {
    tenantId,
    userId,
    tenantShort: tenantId.slice(0, 8),
    userShort: userId.slice(0, 8),
    roles: rolesStr.split(',').filter(Boolean),
  };
}
